<template>
    <transition name="modal" v-if="showModal">
        <div class="vue-modal-mask">
            <div class="vue-modal-wrapper">
                <div class="vue-modal-container">

                    <section class="section section--intro" v-if="!start && !end">
                        <div class="vue-modal-body">
                            <h2 class="intro__title">{{ layout.intro.text }}</h2>
                            <img :src="layout.intro.image" alt="" class="u-responsive-image">
                            <button class="c-button intro__button" @click="startTest">{{ layout.intro.cta }}</button>
                        </div>

                        <div class="vue-modal-esc">
                            <button class="c-ghost-button" @click="closeModal">
                                {{ layout.intro.escape }}
                            </button>
                        </div>
                    </section>

                    <section class="section section--question" v-if="start & !end">
                        <span class="question__separator">{{ layout.separator }}</span>
                        <button class="question__button" @click="addChoice(item.id)" v-for="item in stepContent" :key="item.id">{{ item.label }}</button>
                    </section>

                    <section class="section section--profil" v-if="end">
                        <div class="vue-modal-body">
                            <figure class="profil__images">
                                <img :src="content.values[valueId].image" v-for="valueId in this.profilId.split('').reverse()" :key="valueId">
                            </figure>
                            <h2 class="profil__title">{{ content.profils[this.profilId].title }}</h2>
                            <p class="profil__description">{{ content.profils[this.profilId].description }}</p>

                            <button class="profil__close c-ghost-button" @click="endTest">
                                <i class="profil__icon fas fa-check-circle"></i>
                            </button>
                        </div>
                    </section>
                </div>
                <button class="vue-modal-close c-ghost-button" @click="closeModal">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" src="./vue-modal.scss"></style>
<style lang="scss" src="./vue-test.scss"></style>

<script>
export default
{
    props: ['show', 'loadContent', 'loadLayout'],

    data: () => ({
        showModal: false,
        start: false,
        end: false,
        profilId: '',
        step: 0,
        stepContent: false,
    }),

    methods: {
        reset: function() {
            this.start = false;
            this.end = false;
            this.profilId = '';
            this.step = 0;
            this.stepContent = false;
        },
        closeModal: function() {
            this.showModal = false;
            this.reset();
        },
        openModal: function() {
            this.reset();
            this.showModal = true;
        },
        startTest: function () {
            this.getStepContent();
            this.start = true;
            dataLayer.push({'event': 'interaction', 'interactionCategory': 'testModal', 'interactionPhrase': 'test-start-btn' });
        },
       endTest: function () {
            dataLayer.push({'event': 'interaction', 'interactionCategory': 'testModal', 'interactionPhrase': 'test-end-btn' });
           this.closeModal()
        },
        addChoice: function ($id) {
            this.profilId = this.profilId + $id;
            this.getStepContent();

            if(this.step > 3) {
                let profilTitle = this.content.profils[this.profilId].title;
                // console.log(profilTitle);
                dataLayer.push({'event': 'interaction', 'interactionCategory': 'testModal', 'interactionPhrase': profilTitle });
            }
        },
        getStepContent: function() {
            this.step++;
            if(this.step > 3) {
                this.end = true;
            } else {
                this.stepContent = this.content.steps[this.step];
            }
        }
    },

    mounted() {
        console.log('Component mounted.');

        if(this.show == "true") {
            this.openModal();
        }
    },

    computed: {
        content: function () {
            return  JSON.parse(this.loadContent);
        },
        layout: function () {
            return  JSON.parse(this.loadLayout);
        }
    }
}
</script>

